import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl"

export class PanelOpeningHours implements ClientPage {
  getPageId = (): string => "opening-hours-panel"

  execute = (): void => {
    const closedCheckboxes = document.querySelectorAll<HTMLInputElement>('input[type="checkbox"][name^="hours_"][name$="_closed"]')

    for (const checkbox of closedCheckboxes) {
      const day = checkbox.dataset.day!
      this.toggleTimeInputs(day, checkbox.checked)

      checkbox.addEventListener("change", () => {
        this.toggleTimeInputs(day, checkbox.checked)
      })
    }

    const addButtons = document.querySelectorAll<HTMLButtonElement>("[data-add-range]")
    for (const btn of addButtons) {
      btn.addEventListener("click", () => {
        this.addTimeRange(btn.dataset.addRange!, btn.closest("tr")!)
      })
    }

    const prerenderedExtraRows = document.querySelectorAll<HTMLTableRowElement>("[data-extra-range-day]")
    for (const row of prerenderedExtraRows) {
      row.querySelector("button")?.addEventListener("click", () => {
        row.remove()
        this.reindexExtraRows(row.dataset.extraRangeDay!)
      })
    }
  }

  private addTimeRange = (day: string, originalRow: HTMLTableRowElement): void => {
    const existingCount = document.querySelectorAll(`[data-extra-range-day="${day}"]`).length
    const index = existingCount + 1

    const isClosed = !!document.querySelector<HTMLInputElement>(`input[name="hours_${day}_closed"]`)?.checked

    const newRow = document.createElement("tr")
    newRow.dataset.extraRangeDay = day
    if (isClosed) newRow.style.display = "none"
    newRow.innerHTML = `
      <td></td>
      <td></td>
      <td><input type="time" class="form-control form-control-sm" name="hours_${day}_open_${index}" value="09:00" /></td>
      <td><input type="time" class="form-control form-control-sm" name="hours_${day}_close_${index}" value="22:00" /></td>
      <td><button type="button" class="btn btn-sm btn-outline-secondary">&minus;</button></td>
    `

    this.findLastRowForDay(day, originalRow).after(newRow)
    newRow.querySelector("button")!.addEventListener("click", () => {
      newRow.remove()
      this.reindexExtraRows(day)
    })
  }

  private reindexExtraRows = (day: string): void => {
    const extraRows = document.querySelectorAll<HTMLTableRowElement>(`[data-extra-range-day="${day}"]`)
    extraRows.forEach((row, index) => {
      const newIndex = index + 1
      const openInput = row.querySelector<HTMLInputElement>(`input[name^="hours_${day}_open_"]`)
      const closeInput = row.querySelector<HTMLInputElement>(`input[name^="hours_${day}_close_"]`)
      if (openInput) openInput.name = `hours_${day}_open_${newIndex}`
      if (closeInput) closeInput.name = `hours_${day}_close_${newIndex}`
    })
  }

  private findLastRowForDay = (day: string, originalRow: HTMLTableRowElement): HTMLTableRowElement => {
    let lastRow = originalRow
    let next = originalRow.nextElementSibling as HTMLTableRowElement | null
    while (next?.dataset.extraRangeDay === day) {
      lastRow = next
      next = next.nextElementSibling as HTMLTableRowElement | null
    }
    return lastRow
  }

  private toggleTimeInputs = (day: string, isClosed: boolean): void => {
    const originalRow = document.querySelector<HTMLInputElement>(`input[name="hours_${day}_closed"]`)?.closest("tr")
    const openCell = originalRow?.querySelector<HTMLElement>(`td:nth-child(3)`)
    const closeCell = originalRow?.querySelector<HTMLElement>(`td:nth-child(4)`)
    const addCell = originalRow?.querySelector<HTMLElement>(`td:nth-child(5)`)
    const display = isClosed ? "none" : ""
    if (openCell) openCell.style.display = display
    if (closeCell) closeCell.style.display = display
    if (addCell) addCell.style.display = display

    const openInput = originalRow?.querySelector<HTMLInputElement>(`input[name="hours_${day}_open_0"]`)
    const closeInput = originalRow?.querySelector<HTMLInputElement>(`input[name="hours_${day}_close_0"]`)
    if (openInput) openInput.required = !isClosed
    if (closeInput) closeInput.required = !isClosed

    const extraRows = document.querySelectorAll<HTMLTableRowElement>(`[data-extra-range-day="${day}"]`)
    for (const row of extraRows) row.style.display = display
  }

  onPageClose = (): void => {}
}
